module.exports = __webpack_public_path__ + "img/1524014032.c59ee97f.jpg";